module.exports = __webpack_public_path__ + "img/skarb.e3682817.jpg";